// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"ffd91aa1","135":"c2ab6a82","183":"74ec08f7","220":"9be77a0b","426":"08ee082b","651":"39b25091","681":"40fab74e"}[chunkId] + ".chunk.js";
};